export default () => ({
	currentUser: JSON.parse(localStorage.getItem("vuex"))?.user || null,
	authenticated: false,
	birthday: false,
})
